export const INVESTMENT_TYPE = {
  PAYMENT : {name: 'Pago', color:'var(--dark-accent)'},//LightSeaGreen
  SALE : {name: 'Venta', color:'var(--dark-accent)'},
  BUY : {name: 'Compra', color:'var(--dark-accent)'},
  LIQUIDATION : {name: 'Liquidación', color:'slategrey'},
  CASH_ADJUSTMENT : {name: 'Ajuste', color:'slategrey'}
}